var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-area',{attrs:{"items":_vm.items}}),(_vm.info)?[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('ntp-info',{attrs:{"id":`title-${_vm.npmItem.testId}`,"ntp-info":_vm.npmItem}})],1)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }